import * as React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { IAppState } from '../classes/app';
import { upsertFilter } from '../redux-state/actions/filters';
import { IOption } from '../classes/input-option';

interface StateToProps {
    selectedFilterTags?: any[];
    filters?: string;
    filterOptions?: any
}

interface DispatchToProps {
    updateFilter?: (prop: string, value: string) => void;
}

interface IExternalProps {
    property: string;
}

const stringIsEmpty = (value: string) => !value || value.trim() === '';

export type FiltersProps = StateToProps & DispatchToProps & IExternalProps;

class TagFilter extends React.Component<FiltersProps, null> {
    constructor(props) {
        super(props)
    }
    private updateFilter(prop: string, value: string) {
        let updatedFilterList = this.props.filters.replace(value, '').split('|');
        let updatedFilters = updatedFilterList.filter(x => !stringIsEmpty(x)).join('|');
        this.props.updateFilter(prop, updatedFilters);
    }

    render() {
        const renderTag = (item: any, idx: number) => {
            const label = this.props.property === 'specialties' ? item : this.props.filterOptions[item];
            return (
                <button
                    type="button"
                    key={idx}
                    className="filter-select-tag"
                    onClick={() => {
                        this.updateFilter(this.props.property, item);
                    }}
                >
                    {label ? label : `Unknown ${this.props.property}`}
                </button>
            );
        }

        return (
            <div>
                {this.props.selectedFilterTags ? (
                    <div className="adage-search-facet">
                        {this.props.selectedFilterTags.map(renderTag)}
                    </div>
                ) : null}
            </div>
        );
    }
}

function mapStateToProps(state: IAppState, ownProps: FiltersProps): StateToProps {
    let appliedFilter = [];
    let updatedFilters;
    let updatedFilterOptions;
    if (ownProps.property === 'practice') {
        if (state.filtersState.filters.practice != null && !stringIsEmpty(state.filtersState.filters.practice)) {
            appliedFilter = state.filtersState.filters.practice.split('|');
        }
        updatedFilters = state.filtersState.filters.practice;
        updatedFilterOptions = state.filtersState.filterOptions.practice;
    }
    else if (ownProps.property === 'hospital') {
        if (state.filtersState.filters.hospital != null && !stringIsEmpty(state.filtersState.filters.hospital)) {
            appliedFilter = state.filtersState.filters.hospital.split('|');
        }
        updatedFilters = state.filtersState.filters.hospital;
        updatedFilterOptions = state.filtersState.filterOptions.hospital;
    }
    else if (ownProps.property === 'specialties') {
        if (state.filtersState.filters.specialties != null && !stringIsEmpty(state.filtersState.filters.specialties)) {
            appliedFilter = state.filtersState.filters.specialties.split('|');
        }
        updatedFilters = state.filtersState.filters.specialties;
        updatedFilterOptions = state.filtersState.filterOptions.specialties;
    }

    return {
        selectedFilterTags: appliedFilter,
        filters: updatedFilters,
        filterOptions: updatedFilterOptions
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchToProps {
    return {
        updateFilter: (prop: string, value: string) => {
            dispatch(upsertFilter(prop, value) as any);
        }
    };
}

export const ConnectedFilterTags = connect(
    mapStateToProps,
    mapDispatchToProps
)(TagFilter);
